import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxWidth: 16,
  viewboxHeight: 16,
};

const SpeechBubbleIcon = ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      viewboxHeight={viewboxHeight}
      viewboxWidth={viewboxWidth}
      {...rest}
    >
      <path
        d="M10.754 1.39H5.325a5.443 5.443 0 0 0 0 10.878h.589v2.587a.354.354 0 0 0 .609.241l2.686-2.835h1.545a5.442 5.442 0 0 0 0-10.878v.007Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default SpeechBubbleIcon;
